import { z } from "zod";

const isValidJson = (val: string): boolean => {
  if (!val.trim()) return true;
  try {
    JSON.parse(val);
    return true;
  } catch {
    return false;
  }
};

const optionalJsonString = z
  .string()
  .refine((val) => !val.trim() || isValidJson(val), {
    message: "Must be valid JSON",
  });

export const widgetFormSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be 255 characters or less"),
  data_source_id: z.string().nullable(),
  published: z.boolean(),
  template_ios: optionalJsonString,
  template_android: optionalJsonString,
  template_watchos: optionalJsonString,
});

export type WidgetFormData = z.infer<typeof widgetFormSchema>;
